import { gql } from '@apollo/client';
import {
  Avatar,
  Box,
  Center,
  Flex,
  HStack,
  IconButton,
  LinkBox,
  LinkOverlay,
  Stack,
  Text,
} from '@chakra-ui/react';
import { DocumentNode } from 'graphql';
import NextLink from 'next/link';
import * as React from 'react';

import { CheckIcon } from '@/imports/ui/chakra/feather';

import { GroupAddMembersMember_UserFragment } from './graphql-types/GroupAddMembersMember_UserFragment';

import { AddMemberButton } from './components/AddMemberButton';

export const Member: React.FC<{
  member: GroupAddMembersMember_UserFragment;
  groupId: string;
}> & { userFragment: DocumentNode } = ({ member, groupId }) => {
  const isGroupMember = !!member?.groupLinks?.find(
    (link) => link.groupId === groupId
  );

  return (
    <HStack alignItems="top" w="full" as={LinkBox}>
      <Avatar
        src={member.proxyProfilePictureUrl || undefined}
        name={member.displayName}
        boxSize={10}
        mr="5"
      />
      <Stack direction={['column', 'row']} flex="1">
        <Box flex="1">
          <LinkOverlay as={NextLink} href={`/members/${member._id}`} w="full">
            <Text color="gray.700" fontWeight="semibold">
              {member.displayName}
            </Text>
          </LinkOverlay>
          <Text color="gray.600">
            {member.jobTitle ? member.jobTitle : null}
            {member.company && member.jobTitle ? ' at ' : ''}
            {member.company ? member.company : null}
          </Text>
        </Box>
        <Box>
          {isGroupMember ? (
            <IconButton
              aria-label=""
              isDisabled
              colorScheme="gray"
              icon={<CheckIcon />}
            />
          ) : (
            <AddMemberButton groupId={groupId} userId={member._id} />
          )}
        </Box>
      </Stack>
    </HStack>
  );
};

Member.userFragment = gql`
  fragment GroupAddMembersMember_UserFragment on User {
    _id
    displayName
    jobTitle
    company
    nameTitle
    proxyProfilePictureUrl(
      input: { w: 140, h: 140, fit: "facearea", facepad: 10.0 }
    )
    groupLinks {
      _id
      userId
      groupId
    }
  }
`;
